import React, { useEffect } from 'react';

import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import Grid from '@mui/material/Grid';

import Page from 'components/Page';
import Button from 'components/Form/Button';

import utils from 'utils';

import sphp from 'assets/sphp.png';

import './index.scss';

const PrivySuccessSigningPage = () => {
  const history = useHistory();

  const goHome = () => {
    localStorage.setItem('dataType', 'privydone');
    history.push('/home');
  };

  useEffect(() => {
    const hasToken = utils.store.get('token');
    if (!hasToken) {
      history.push('/login');
    }
  }, [history]);

  return (
    <>
      <Helmet>
        <title>JULO - Tanda Tangan Sukses</title>
      </Helmet>
      <Page useHeader={true}>
        <div className='center-align-offer-div'>
          <Grid container justifyContent='center' alignItems='center'>
            <Grid item xs={12} sm={7} md={5}>
              <Grid container justifyContent='center' spacing={2}>
                <Grid item>
                  <p style={{ textAlign: 'center', paddingTop: '75px' }}>
                    <img src={sphp} alt='logo' />
                  </p>
                  <p
                    className='successPrivyHeader'
                    style={{ textAlign: 'center', paddingTop: '20px' }}
                  >
                    SELAMAT
                  </p>
                  <p
                    className='successPrivyContent'
                    style={{
                      textAlign: 'center',
                      paddingTop: '10px',
                      paddingLeft: '10px',
                      paddingRight: '10px',
                    }}
                  >
                    Surat Konfirmasi Rincian Transaksi Pendanaan Anda telah
                    ditandatangani dan telah berhasil diunggah. Dana pinjaman
                    akan di transfer ke rekening bank Anda dalam 1 hari kerja.
                    Silahkan review jadwal pembayaran cicilan di halaman tagihan
                  </p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <div className='grab-footer'>
            <div style={{ padding: '16px' }}>
              <Button onClick={goHome}>Lanjutkan</Button>
            </div>
          </div>
        </div>
      </Page>
    </>
  );
};

export default PrivySuccessSigningPage;
